import { format } from "date-fns";

export function formatDateWithTimezone(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
}
